'use strict';

var SearchDirective = function () {

  var link = function link (scope, el, attrs) {
    scope = scope.$parent;
    var vm = scope.$parent.vm;
    var input = el[0];

    scope.$watch('vm.isEditing', function (editing) {
      if (editing) {
        input.focus();
      } else {
        input.blur();
      }
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    scope: {},
    link: link
  };
};

module.exports = SearchDirective;


// WEBPACK FOOTER //
// ./src/app/settings/directives/FocusOnEditDirective.js